export const CITATION_MARKER_PATTERN = /\[\^[a-z_]+-\d+\]/g

/**
 * Max characters accepted for any AI dossier free-form text block. Shared by
 * the `max_length` validation on every dossier update service and by the
 * client-side `maxLength` on the Arc settings editor, so the server limit and
 * the input cap can't drift apart.
 */
export const DOSSIER_MAX_LENGTH = 20000

/**
 * Max characters for the learned profile (users.ai_learned_profile). The nightly job keeps it
 * near 300 words; this only bounds a hand edit in Arc settings.
 */
export const LEARNED_PROFILE_MAX_LENGTH = 4000

/**
 * Longest voice memo Arc will transcribe, shared so the browser recorder's
 * auto-stop and the server's guard can't drift apart. Slack has enforced this
 * cap since voice memos shipped there; the Atlas composer matches it.
 */
export const MAX_VOICE_MEMO_DURATION_MS = 5 * 60 * 1000

/**
 * Slack for measurement, NOT extra recording time — the recorder still hard-stops
 * at MAX_VOICE_MEMO_DURATION_MS, so nobody can deliberately record past it.
 *
 * Two different clocks disagree about the same recording: the browser stops it off
 * a one-second interval, so the captured audio always runs a fraction over the cap,
 * and Whisper then measures that real length. Comparing the two strictly would
 * reject a memo the user recorded exactly as far as our own UI let them — telling
 * someone who complied that they must record something shorter. Anything genuinely
 * over the limit still exceeds this and is refused untranscribed.
 */
export const VOICE_MEMO_DURATION_TOLERANCE_MS = 3 * 1000

/**
 * Bitrate the browser recorder asks for. Speech only needs a fraction of this —
 * Whisper resamples to 16 kHz mono regardless — so it is set low to keep a
 * five-minute memo around 1.8 MB, which is what lets the server hold a tight
 * byte ceiling. Advisory: Safari may ignore it, so the ceiling keeps headroom.
 */
export const VOICE_MEMO_AUDIO_BITS_PER_SECOND = 48_000

/**
 * How long a sent voice memo may sit at "transcribing" before it counts as stuck
 * and can be retried. Comfortably past the server's transcription timeout, so a
 * retry never races an attempt that is still genuinely running.
 */
export const VOICE_MEMO_TRANSCRIPTION_STALE_MS = 2 * 60 * 1000
